<template>
  <div class="text-white/50">
    <span>50420 경상남도 밀양시 밀양대로 2047</span>
  </div>
</template>
